import { ISelectItem } from "@components/inputs/select/Select.types";
import React from "react";

import { ActionState } from "../../enums";
import { TRecordType } from "../../global.types";
import File, { IFile } from "../fileUploader/File";
import { IFocusableItemProps } from "../focusManager";
import { TId } from "../table";
import {
    getCustomFileContextMenuItems,
    getFileContextMenuItems,
    getFileIconByName,
    getFileNameOnly,
    GridMode,
    isContextMenuDisabled
} from "./File.utils";

export interface IFileGridProps {
    focusableProps: IFocusableItemProps;
    files: IFile[];
    readOnlyFiles?: IFile[];
    isReadOnly?: boolean;
    isDeleteDisabled?: boolean;
    showRemoveAction?: boolean;
    filesToRemove?: TRecordType<boolean>;
    onRemoveAction?: (fileId: TId[], forceState?: boolean) => void;
    onFileClick?: (fileId: TId) => void;
    customContextMenuItems?: ISelectItem[] | ((fileId: TId) => ISelectItem[]);
    onContextMenuSelection?: (item: ISelectItem, id?: string) => void;
    onModeChange?: (mode: GridMode) => void;
    gridMode: GridMode;
    formAttachmentsTitle?: string;
}

export function getRemoveActionState(props: IFileGridProps, id: TId): ActionState {
    if (!props.showRemoveAction) {
        return ActionState.None;
    }

    if (id === formAttachmentsFolderId || props.gridMode === GridMode.FormAttachments) {
        return ActionState.Disabled;
    }

    return props.filesToRemove[id.toString()] ? ActionState.Active : ActionState.Inactive;
}

export const formAttachmentsFolderId = "formAttachmentsFolder";

export default class FileGrid extends React.PureComponent<IFileGridProps> {
    static defaultProps: Partial<IFileGridProps> = {
        customContextMenuItems: []
    };

    get hasReadOnlyFiles(): boolean {
        return this.props.readOnlyFiles?.length > 0;
    }

    handleRemoveClick = (fileId: TId): void => {
        this.props.onRemoveAction?.([fileId]);
    };

    handleToggleMode = (): void => {
        this.props.onModeChange?.(GridMode.FormAttachments);
    };

    render() {
        const isEntityAttachmentsMode = this.props.gridMode === GridMode.EntityAttachments;
        const files = isEntityAttachmentsMode ? this.props.files : this.props.readOnlyFiles;
        return <>
            {this.hasReadOnlyFiles && isEntityAttachmentsMode &&
                <File id={formAttachmentsFolderId}
                      key={formAttachmentsFolderId}
                      name={this.props.formAttachmentsTitle}
                      isFormAttachment={true}
                      icon={"AttachmentsFolder"}
                      onClick={this.handleToggleMode}
                      removingAction={getRemoveActionState(this.props, formAttachmentsFolderId)}
                />
            }
            {files.map((file, index) => {
                return (
                    <File id={file.id} key={file.id.toString()}
                          name={getFileNameOnly(file.name, true)}
                          icon={getFileIconByName(file.name)}
                          isFormAttachment={!isEntityAttachmentsMode}
                          removingAction={getRemoveActionState(this.props, file.id)}
                          onRemoveActionClick={this.handleRemoveClick}
                          onClick={this.props.onFileClick}
                          contextMenuItems={this.props.onContextMenuSelection && [...getFileContextMenuItems(this.props.isReadOnly || !isEntityAttachmentsMode, true, this.props.isDeleteDisabled), ...getCustomFileContextMenuItems(this.props.customContextMenuItems, file.id)]}
                          onContextMenuSelection={this.props.onContextMenuSelection}
                          isContextMenuDisabled={isContextMenuDisabled}
                          passProps={this.props.focusableProps}
                    />
                );
            })}
        </>;
    }
}